import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";

export function IAExplain({ numero, texto, variant = "chip" }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const abrir = async () => {
    setOpen(true);
    if (data) return;
    setLoading(true);
    try {
      const res = await api.post("/ia/explicar", { numero, texto });
      setData(res.data);
    } catch (e) {
      setData({ explicacion: "No se pudo generar la explicación en este momento.", disclaimer: "" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button onClick={(e) => { e.stopPropagation(); abrir(); }} data-testid={`ia-explicar-${numero}`}
        className={variant === "chip"
          ? "inline-flex items-center gap-1 text-[11px] font-semibold text-[#FF5625] hover:underline"
          : "inline-flex items-center gap-1 text-xs font-semibold text-[#FF5625] hover:underline"}>
        <Sparkles size={13} /> ¿Por qué importa?
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-lg" data-testid={`ia-dialog-${numero}`}>
          <DialogHeader>
            <DialogTitle className="text-[#0E2A47] flex items-center gap-2">
              <Sparkles size={18} className="text-[#FF5625]" /> Requisito {numero}
            </DialogTitle>
          </DialogHeader>
          {loading ? (
            <div className="py-8 text-center text-[#0E2A47]/50">Generando explicación…</div>
          ) : (
            <div>
              <p className="text-sm text-[#0E2A47]/85 leading-relaxed whitespace-pre-line">{data?.explicacion}</p>
              {data?.disclaimer && (
                <p className="mt-4 text-[11px] italic text-[#0E2A47]/40 border-t border-[#E2E8F0] pt-3">{data.disclaimer}</p>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export function FotoImg({ id, className }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let active = true;
    api.get(`/calidad/foto/${id}`, { responseType: "blob" })
      .then((r) => { if (active) setUrl(URL.createObjectURL(r.data)); })
      .catch(() => {});
    return () => { active = false; };
  }, [id]);
  if (!url) return <div className={`bg-[#E2E8F0] animate-pulse ${className}`} />;
  return <img src={url} alt="evidencia" className={className} />;
}
